import { render } from "./AttrJSON.vue?vue&type=template&id=eb85ee20&scoped=true"
import script from "./AttrJSON.vue?vue&type=script&lang=js"
export * from "./AttrJSON.vue?vue&type=script&lang=js"

import "./AttrJSON.vue?vue&type=style&index=0&id=eb85ee20&lang=css"
import "./AttrJSON.vue?vue&type=style&index=1&id=eb85ee20&lang=css"
import "./AttrJSON.vue?vue&type=style&index=2&id=eb85ee20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb85ee20"],['__file',"src/components/widgets/components_core/AttrJSON.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb85ee20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb85ee20', __exports__)) {
    api.reload('eb85ee20', __exports__)
  }
  
  module.hot.accept("./AttrJSON.vue?vue&type=template&id=eb85ee20&scoped=true", () => {
    api.rerender('eb85ee20', render)
  })

}


export default __exports__